<!--
 * @Author: p_fy
 * @LastEditors: Do not edit
 * @Date: 2019-07-25 10:54:07
 * @LastEditTime: 2019-08-14 16:30:35
 * @Version: 1.0
 * @Description: 描述:仓库订单页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->
<template>
  <div class="content-container">
    <div class="demand-head">
      <div class="slider-list" >
        <div :class="{ 'selected': !state}" @click="toggleStateOne" class="item">普仓订单</div>
        <div :class="{ 'selected': state}" @click="toggleStateTwo" class="item">罐区订单</div>
      </div>
    </div>

    <div v-if="!state">
      <storageOrderList />
    </div>
    <div v-if="state">
      <tankOrderList />
    </div>
  </div>
</template>

<script>
import storageOrderList from './storageOrderList'
import tankOrderList from './tankOrderList'

export default {
  name: 'ReserveOrderList',
  components: {
    storageOrderList,
    tankOrderList
  },
  data: function() {
    return {
      state: false
    }
  },
  created() {
    if (this.$route.params.noticeId != undefined) {
      if (this.$route.params.data.noticeModuleVal.type == 1) {
        this.state = false
      } else {
        this.state = true
      }
    }
  },
  methods: {
    // 列表切换
    toggleStateOne() {
      this.state = false
    },
    toggleStateTwo() {
      this.state = true
    }
  }
}
</script>
<style scoped lang="scss">
  @import "@/styles/standardColor.scss";
  $main-color: #be2316;
  .content-container {
    .demand-head {
      padding: 1rem;
      padding-bottom: 0!important;
      border-style: solid;
      border-color: #f1f1f1;
      background-color: #ffffff;
      .slider-list {
        display: block;
        margin: 0 0;
        height: 36px;
        overflow: auto;
        white-space: nowrap;
        border-bottom: 1px solid #f1f1f1;
        &::-webkit-scrollbar {
          height: 0px !important;
          width: 0px !important;
        }
        &::-moz-scrollbar {
          height: 0px !important;
          width: 0px !important;
        }
        .item {
          // height: 35px;
          height: calc(100% - 1px);
          display: inline-block;
          width: 100px;
          font-size: 16px;
          font-weight: 600;
          line-height: 35px;
          margin-right: 12px;
          border-bottom: 1px solid rgba(0, 0, 0, 0);
          text-align: center;
          transition: all 1s;
          color: black;
          cursor: pointer;
          &.selected {
            border-bottom: 1px solid $main-color;
            transition: all 1s;
            color: $main-color;
          }
        }
      }
    }
  }
</style>
